import {
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    CLEAR_CHANGE_PASSWORD_STATE,
  } from "../actions/ChangePasswordAction"
  
  const initialState = {
    loading: false,
    success: false,
    error: null,
    message: "",
  }
  
  const changePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_PASSWORD_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
          message: "",
        }
  
      case CHANGE_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          error: null,
          message: action.payload,
        }
  
      case CHANGE_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload,
          message: "",
        }
  
      case CLEAR_CHANGE_PASSWORD_STATE:
        return {
          ...initialState,
        }
  
      default:
        return state
    }
  }
  
  export default changePasswordReducer
  